export const routesList =
    [
        {
            "tutorialPage": "/dashboards/master-dashboard",
            "listPage": "/master-data/container-master"
        },
        {
            "tutorialPage": "/dashboards/depot-dashboard",
            "listPage": "/master-data/depot-master"

        },
        {
            "tutorialPage": "/dashboards/user-dashboard",
            "listPage": "/master-data/user-master"

        },
        {
            "tutorialPage": "/dashboards/department-dashboard",
            "listPage": "/master-data/department-master"

        },
        {
            "tutorialPage": "/dashboards/role-dashboard",
            "listPage": "/master-data/role-master"

        },
        {
            "tutorialPage": "/dashboards/currency-dashboard",
            "listPage": "/master-data/currency-master"

        },
        {
            "tutorialPage": "/dashboards/customer-dashboard",
            "listPage": "/master-data/customer-master"

        },
        {
            "tutorialPage": "/dashboards/charge-dashboard",
            "listPage": "/master-data/charge-master"

        },
        {
            "tutorialPage": "/dashboards/role-dashboard",
            "listPage": "/master-data/role-master"

        },
        {
            "tutorialPage": "/dashboards/region-dashboard",
            "listPage": "/master-data/region-master"
        },
        {
            "tutorialPage": "/one-way/insurance-master",
            "listPage": "/master-data/insurance-master"
        },
        {
            "tutorialPage": "/one-way/request-processing",
            "listPage": "/requests/request-processing"
        },
        {
            "tutorialPage": "/one-way/my-requests-dashboard",
            "listPage": "/requests/my-requests"
        },
        {
            "tutorialPage": "/one-way/request",
            "listPage": "/requests/request-data"
        },
        {
            "tutorialPage": "/dashboards/user-service-mapping-dashboard",
            "listPage": "/master-data/user-service-mapping"
        },
        {
            "tutorialPage": "/dashboards/master-dashboard",
            "listPage": "/master-data/role-master"
        },
        {
            "tutorialPage": "/dashboards/user-depot-access-dashboard",
            "listPage": "/master-data/user-depot-access"
        },
        {
            "tutorialPage": "/dashboards/mnr-dashboard",
            "listPage": "/master-data/mnr-master"
        },
        {
            "tutorialPage": "/dashboards/tms-dashboard",
            "listPage": "/master-data/ticket-management"
        },
        {
            "tutorialPage": "/dashboards/approval-dashboard",
            "listPage": "/master-data/approval-management-list"
        },
        {
            "tutorialPage": "off-hire-containers",
            "listPage": "/off-hire-containers",
        },
        {
            "tutorialPage": "/ops-date-change",
            "listPage": "/ops-date-change/list",
        },
        {
            "tutorialPage": "/dashboards/my-approvals",
            "listPage": "/master-data/my-approval-list",
        },
        {
            "tutorialPage": "/dashboards/stock-report",
            "listPage": "/dashboards/stock-report/list",
        },
    ]
